import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Containers from '../../../components/pages/Containers';
import { ROUTE_PATHS } from '../constants';

type Props = React.ComponentPropsWithoutRef<'div'> & {};

const RegularReleasePartyRoutes: React.FunctionComponent<Props> = () => {
  return (
    <Routes>
      <Route path={ROUTE_PATHS.BASE_ROUTE} element={<Containers />} />
    </Routes>
  );
};

export default RegularReleasePartyRoutes;
